/* eslint-disable no-console */
// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
// MODULE - Modal

import { logger } from '@/util/logger';

const $ = window.$;
window.modals = {};

export default function(id, settings) {
	window.modals[id] = this;

	this.s = settings || {};
	this.id = id;
	this.useBackdrop = this.s.useBackDrop || false;

	this.backdropVisible = function() {
		return $('.js-modal-backdrop').is(':visible');
	};

	// cached selectors, defined via cacheSelectors method
	this.$outer = $('#' + this.id);
	this.$content = this.$outer.find('.js-modal-content');
	this.$close = this.$outer.find('.js-modal-close');
	this.$rvPopout = this.$outer.find('.js-rv-popout');
	this.$indicator = this.$outer.find('.js-modal-indicator');
	this.$currentActivator;

	// State
	this.height = this.$content.outerHeight();
	this.width = this.$content.width();
	this.lastAnchorPosition;

	// Cached information about the element that activated the modal
	this.activatorWidth = 0;
	this.activatorID = '';

	// Settings for modals that get positioned next to their trigger (instead of centered in the window)
	this.BASE_OFFSET = 20;
	this.MIN_CLEARANCE = 60;
	this.MODAL_ARROW_WIDTH = 11;
	this.VERTICAL_CENTERING_ADJUSTMENT = 0.475;
	this.minWidth = this.s.minWidth || 304;
	this.maxWidth = this.s.maxWidth || 400;

	this.isActiveModal = function(id) {
		return this.id === id;
	};

	this.calcVerticalCenter = function(offset) {

        var modalHeight = this.$outer.outerHeight(true);
		var docHeight = $(document).height();

		if (offset > docHeight - modalHeight) {
			// expand popup from the bottom if expanding from top would 
			// cause the popup to overflow the document or window height.
			if (offset < $(window).height() + $(window).scrollTop()) {
				// dock to bottom of window rather than document when possible
				return docHeight - (docHeight - $(window).height()) + $(window).scrollTop() - modalHeight - this.BASE_OFFSET;
			} else {
				return docHeight - modalHeight - this.BASE_OFFSET;
			}
		}

		// get vertical center position based on offset
		return Math.max(this.BASE_OFFSET, (offset - modalHeight * this.VERTICAL_CENTERING_ADJUSTMENT));
	};


	this.setPosition = function(positionLeft, positionTop) {
		this.$outer.css({
			'left': positionLeft,
			'top': positionTop
		});
	};

	this.setWidth = function(val) {
		var w = val <= this.maxWidth ? val : this.maxWidth;

		this.width = w;

		this.$outer.css('width', this.width);

	};

	this.setHeight = function () {
		// don't need to do this for modals
		if (this.s.isModal) return;

		this.height = this.$content.outerHeight(true) + 2;
		this.$outer
			.css('height', '')
			.css('height', this.height);
	};

	// show/hide methods
	this.open = function ($activator) {
		var that = this;
		this.$currentActivator = $activator;

		if (!$activator || !$activator.length) {
			logger.warn('No activator node passed to Modal.open()');
			this.$currentActivator = $(document);
			$activator = $(document);
		}

		// beforeOpen is meant to be overwritten when Modal is imported
		if (typeof this.beforeOpen === 'function') {
			this.beforeOpen($activator);
		}

		if (this.s.useAnchoredPosition) {
			this.handlePositioning($activator);
		}

		if (this.s.useBackdrop) {
			$('.js-modal-backdrop')
				.addClass('is-showing')
				.attr('data-target', this.id);
		}

		this.setHeight();

		this.$outer.addClass('is-showing');

		this.isOpen = true;

		if (typeof this.afterOpen === 'function') {
			this.afterOpen($activator);
		}

		if (typeof this.s.onOpen === 'function') this.s.onOpen();

		this.activatorID = $activator.attr('id');

		if (this.s.closeOnClickOutside) {
			$(document).on('click.outsideClick', function (e) {
				var x1 = that.$outer.offset().left;
				var x2 = x1 + that.$outer.width();
				var y1 = that.$outer.offset().top;
				var y2 = y1 + that.$outer.height();
				if (e.pageX < x1 || e.pageX > x2 || e.pageY < y1 || e.pageY > y2) {
					that.close();
				}
			});
		}
	};

	this.close = function() {
		this.$outer.removeClass('is-showing');

		$(document).off('.outsideClick');

		if (this.backdropVisible()) {
			$('.js-modal-backdrop').removeClass('is-showing');
		}

		this.isOpen = false;


		if (typeof this.afterClose === 'function') {
			this.afterClose();
		}

		this.activatorID = '';
	};

	this.handleModalClose = function($elem) {
		var d = $elem.data();

		// If click is inside the receipt viewer, don't continue with close logic
		if ($elem.parents('.js-rv-outer').length) return;

		// If a modal is returned, we know that this is another modal activator
		if ($elem.attr('id') !== this.activatorID && this.id === d.target) {
			return;
		}
		this.close();
	};

	function _getActivatorOffset($activator) {
		return $activator.offset().top + $activator.offset().left;
	}

	this.handlePositioning = function ($activator) {
		var o = $activator.offset();
		var indicatorAdjustment = this.s.useOriginIndicator ? this.MODAL_ARROW_WIDTH : 0;
		var origin = this.s.origin;

		var positionLeft = 12; // default left position is 12px because that sets it just inside the container
		var positionTop = 0;

		var spaceToRight = window.getWindowWidth() - (o.left + $activator.width()) - indicatorAdjustment;
		var spaceToLeft = o.left - indicatorAdjustment;
		var booShowOnRight = false;
		var availableWidthLeft = 0;
		var availableWidthRight = 0;

		// Get top position
		// ---------------------
		switch (origin) {
		case 'top':
			positionTop = o.top - 8;
			break;
		case 'bottom':
			// to account for borders and box shadow
			positionTop = o.top + $activator.height() + 6;
			break;
		default:
			availableWidthRight = spaceToRight - this.MIN_CLEARANCE;
			availableWidthLeft = spaceToLeft - this.MIN_CLEARANCE;

			positionTop = this.calcVerticalCenter(o.top);
			break;
		}

		this.$outer.removeClass('is-mobile-view');

		// additional adjustment to account for MUI icons which are larger and take
		// up more horizontal space than the older icons
		if ($activator.width() === 24) {
			indicatorAdjustment += 6
		}
		// Get left position
		// ------------------------------
		switch (origin) {
		case 'left':
			// prefer displaying to left if there is room
			if (availableWidthLeft > this.minWidth) {
				// to left
				this.setWidth(availableWidthLeft);

				positionLeft = o.left - this.$outer.width() - indicatorAdjustment - this.activatorWidth;
			} else if (availableWidthRight > this.minWidth) {
				// to right
				this.setWidth(availableWidthRight);

				positionLeft = o.left + this.activatorWidth + indicatorAdjustment;
				booShowOnRight = true;
			} else {
				this.$outer.addClass('is-mobile-view');
				this.$outer.css('width', '');
				positionLeft = 0;
			}

			break;
		case 'right':
			// prefer displaying to right if there is room
			if (availableWidthRight > this.minWidth) {
				// to right
				this.setWidth(availableWidthRight);

				positionLeft = o.left + this.activatorWidth + indicatorAdjustment;
				booShowOnRight = true;
			} else if (availableWidthLeft > this.minWidth) {
				// to left
				this.setWidth(availableWidthLeft);

				positionLeft = o.left - this.$outer.width() - indicatorAdjustment - this.activatorWidth;
			} else {
				this.$outer.addClass('is-mobile-view');
				this.$outer.css('width', '');
				positionLeft = 0;
			}

			break;
		default:
			// if origin is top or bottom, we do not care about minimum clearance, we will
			// anchor from the right, and if there is not enough space to display the full modal, anchor to 0
			if (spaceToLeft > this.maxWidth) {
				this.setWidth(spaceToLeft);

				positionLeft = o.left + $activator.width() - this.$outer.width() - parseInt(this.$outer.css('padding-right'));
			} else {
				this.$outer.addClass('is-mobile-view');
				this.$outer.css('width', '');
				positionLeft = 0;
			}
			break;
		}

		// set modal width according to calculated available width
		this.setPosition(positionLeft, positionTop);

		if (this.s.useOriginIndicator) {
			// -2 just makes the arrow line up better
			// add top padding back in
			var verticalAdjustment = -2;
			var paddingTop = parseInt($activator.css('padding-top'), 10);

			// the -2px adjustment is only needed to vertically center the receipt icons in use on 
			// the draft, wallet, and approval pages. The new embark MUI icons do not need this, but
			// do need an additional offset to add padding back into the offset 
			verticalAdjustment = paddingTop || -2;

			this.setIndicatorPosition(o.top - positionTop + verticalAdjustment, booShowOnRight);
		}
	};

	// add data target to all close elements belonging to this modal.
	this.$close.attr('data-target', id);

	this.$content.createFocusGuard();


	var that = this;

	if (this.s.useAnchoredPosition) {
		$(window).on('resize scroll', function(e) {
			if (!that.isOpen) return;
			var $a = that.$currentActivator && that.$currentActivator.length ? that.$currentActivator : that.$activator;
			
			// Don't need to do this if ther is not an active anchor
			if (!$a.length) return;
			
			// don't update position for scroll events where anchor position has not changed.
			if (e.type === 'scroll' && that.lastAnchorPosition === _getActivatorOffset($a)) return;
			
			that.lastAnchorPosition = _getActivatorOffset($a);

			if (that.isOpen && that.activatorID) {
				that.handlePositioning($a);
			}
		});
	}
}

// ------------------------------
// attach generic modal events
// -------------------------------
$(document).on('click', '.js-modal-close', function() {
	window.modals[$(this).data().target].close();
});

$(document).on('keyup', '.js-modal-close', function(e) {
	if (window.isEnterOrSpaceKey(e)) {
		window.modals[$(this).data().target].close();
		e.preventDefault();
	}
});

$(document).on('click open', '.js-modal-open', function(e) {
	var $activator = $(this);
	var modal = window.modals[$activator.data().target];

	if (modal.isOpen && modal.activatorID === $activator.attr('id')) {
		// simply close modal if it is already open.
		modal.handleModalClose($activator);
		e.preventDefault();
		e.stopPropagation();
		return;
	}

	modal.activatorWidth = $activator.width();

	modal.open($(this));
});

$(document).on('click', '.has-modal-open', function(e) {
	var modal = window.modals[$(this).data().target];

	modal.handleModalClose($(e.target));
});